import request from '@/api/request'

const baseUrl = '/admUser'

function buildParams(data = {}) {
  const params = new URLSearchParams()
  Object.keys(data).forEach((key) => {
    const value = data[key]
    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item !== undefined && item !== null && item !== '') {
          params.append(key, item)
        }
      })
      return
    }
    if (value !== undefined && value !== null && value !== '') {
      params.append(key, value)
    }
  })
  return params.toString()
}

export function pageAdmUser(current = 1, size = 20) {
  return request({
    url: `${baseUrl}/page?current=${current}&size=${size}`,
    method: 'get'
  })
}

export function listAdmUser() {
  return request({
    url: baseUrl,
    method: 'get'
  })
}

export function getAdmUser(id) {
  return request({
    url: `${baseUrl}/${id}`,
    method: 'get'
  })
}

export function addAdmUser(data) {
  return request({
    url: `${baseUrl}/`,
    method: 'post',
    data
  })
}

export function updateAdmUser(data) {
  return request({
    url: `${baseUrl}/`,
    method: 'put',
    data
  })
}

export function deleteAdmUser(idList = []) {
  const params = buildParams({ idList })
  return request({
    url: `${baseUrl}/${params ? `?${params}` : ''}`,
    method: 'delete'
  })
}

export function listConfigurableMenus() {
  return request({
    url: `${baseUrl}/menus`,
    method: 'get'
  })
}

export function listUserMenus(id) {
  return request({
    url: `${baseUrl}/${id}/menus`,
    method: 'get'
  })
}

export function saveUserMenus(id, menuIdList = []) {
  return request({
    url: `${baseUrl}/${id}/menus`,
    method: 'put',
    data: {
      menuIdList
    }
  })
}
